import { BASE_URL } from '../endpoints'
import { get, post } from '../https'

export const getAllPolicies = (): Promise<unknown> => {
  return get(`${BASE_URL}/policies/published`)
}
export const getAllPublishedPolicies = (): Promise<unknown> => {
  return get(`${BASE_URL}/policies/published`)
}
export const getAllPoliciesAgreements = (): Promise<unknown> => {
  return get(`${BASE_URL}/policies/agreements`)
}

export const getAllPolicyById = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/policies/published/${id}`)
}
export const getPublishedPolicyById = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/policies/published/${id}`)
}

export const createPolicyAgreement = (id: string): Promise<unknown> => {
  return post(`${BASE_URL}/policies/${id}/agreements`, null)
}
